module.exports = __webpack_public_path__ + "static/Logo_5-66c0a6a06b04853e2840c918ce3996c3.png";